module.exports = __webpack_public_path__ + "img/user.de01aef7.svg";